import {Component, Inject, InjectionToken} from '@angular/core';
import {ContextState} from '../../types/context-state';
import {ContextMenuItem} from '../../types/context-menu-item';
import {ContextMenuEntry} from '../../types/context-menu-entry';
import {Submenu} from '../../types/submenu';

export const CONTEXT_MENU_OVERLAY_DATA = new InjectionToken<ContextState>('CONTEXT_MENU_OVERLAY_DATA');

@Component({
  selector: 'ctx-context-menu-overlay',
  template: `<div class="context-menu">
  <ul class="context-list">
    <ng-container *ngFor="let item of contextState.context">
      <ctx-context-menu-item *ngIf="isAction(item)" [item]="item"></ctx-context-menu-item>
      <ctx-submenu *ngIf="isSubmenu(item)" [item]="item"></ctx-submenu>
    </ng-container>
  </ul>
</div>
`,
  styles: [`::ng-deep .context-menu{min-width:50px;min-height:20px;background:#fff;border:1px solid #a7a7a7;box-shadow:0 0 10px 0 rgba(0,0,0,.5)}::ng-deep .context-menu .context-list{margin:0;padding:0}::ng-deep .context-menu .context-list .context-list-item{list-style:none;padding:0;min-width:200px;cursor:pointer}::ng-deep .context-menu .context-list .context-list-item .flex-container{display:flex}::ng-deep .context-menu .context-list .context-list-item .shortcut{font-size:.8em;opacity:.5}::ng-deep .context-menu .context-list .context-list-item .submenu{display:none;position:absolute;margin-top:-20px}::ng-deep .context-menu .context-list .context-list-item:hover{background:rgba(0,0,0,.1)}::ng-deep .context-menu .context-list .context-list-item:hover>.submenu{display:block}`]
})
export class ContextMenuComponent {
  constructor(
    @Inject(CONTEXT_MENU_OVERLAY_DATA) public contextState: ContextState
  ) {}

  /**
   * Check if this is an action
   * @param item
   * @returns
   */
  public isAction(item: ContextMenuEntry): boolean {
    return !!(item as ContextMenuItem).action && !(item as ContextMenuItem).hideMenu && (item as ContextMenuItem).inContext;
  }

  /**
   * Is this context menu entry a submenu?
   * @param item
   */
  public isSubmenu(item: ContextMenuEntry): boolean {
    return !!(item as Submenu).children;
  }
}
